"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridResizeIndicator = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const base_1 = require("../../../../../design/themes/base");
exports.StyledGridResizeIndicator = styled_components_1.default.div `
    position: absolute;
    top: 0;
    bottom: 0;
    left: var(--grid-core-resize-indicator-left-position, 0);
    display: var(--grid-core-resize-indicator-display, none);
    width: 1px;
    background-color: ${base_1.baseTheme.colorAccent.var()};
    pointer-events: none;
`;
//# sourceMappingURL=GridResizeIndicator.styles.js.map